import React, { useState, useEffect, useRef } from "react";
import {
  Row,
  Col,
  Card,
  Navbar,
  Nav,
  NavDropdown,
} from "react-bootstrap";
import { Form } from "antd";
import moment from "moment";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ConsultasAPI from "../../../shared/helpers/consultasAPI";
import TablasExtractos from "./TablasExtractos";
import { Link } from "react-router-dom";
import { FcCalendar } from "react-icons/fc";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navigate } from 'react-router-dom';
import SorteoComponent from "./PdfExtracto";
const FormItem = Form.Item;

function agregarCeros(numero) {
  const numeroString = numero.toString(); // Convertir el número a string
  const cerosFaltantes = 4 - numeroString.length; // Calcular la cantidad de ceros faltantes
  if (cerosFaltantes > 0) {
    const ceros = "0".repeat(cerosFaltantes); // Generar una cadena de ceros
    return ceros + numeroString; // Concatenar los ceros y el número
  }
  return numeroString; // Devolver el número sin cambios si ya tiene 4 dígitos o más
}

const SubirExtracto = () => {
  const URL_EXTRACTOREGISTRO = window.API_ROUTES.EXTRACTOREGISTRO;
  const URL_TIPOSORTEO = window.API_ROUTES.TIPOSORTEO;
  const URL_EXTRACTO = window.API_ROUTES.EXTRACTOS;
  const [form] = Form.useForm();
  const [fecha, setFecha] = useState({
    fechaMuestra: moment().format("DD/MM/YYYY"),
    fechaComparar: moment().format("YYYY-MM-DD"),
  });
  const [datosTablas, setDatosTablas] = useState([]);
  // const [setCantidad] = useState();

  useEffect(() => {
    cargarTabla();
  }, [fecha]);

  const cargarTabla = () => {
    // Traemos el extracto del back, seleccionando una fecha
    ConsultasAPI.ObtenerObjeto(
      URL_EXTRACTO,
      "?fecha_sorteo=" + fecha.fechaComparar
    ).then((response) => {
      // setCantidad(response.data.length);
      let datosTablas = [];
      let contador = 0;
      let cantidad = response.data.length;
      if (response.data.length > 0) {
        response.data.forEach((ext) => {
          let datosExtracto = [];
          ConsultasAPI.ObtenerObjeto(URL_TIPOSORTEO, ext.tipo).then(
            (response) => {
              let hora = response.data.hora_sorteo;
              ConsultasAPI.ObtenerObjeto(
                URL_EXTRACTOREGISTRO,
                "?id=" + ext.id
              ).then((response) => {
                // Con el extracto obtenido traemos los registros, con el id extracto
                if (response.data.length > 0) {
                  for (let i = 10; i > 0; i--) {
                    datosExtracto.push({
                      key: i,
                      numPremio1_10: `${11 - i}° Premio`,
                      numero1_10: agregarCeros(response.data[i + 9].numero),
                      numPremio11_20: `${21 - i}° Premio`,
                      numero11_20: agregarCeros(response.data[i - 1].numero),
                      tipo: ext.tipo_detalle,
                      tipoid: ext.tipo,
                      sorteo: ext.sorteo,
                      fecha: fecha.fechaMuestra,
                      hora: hora,
                      caducidad_cuatriplona: ext.caducidad_cuatriplona ? ext.caducidad_cuatriplona : '',
                      caducidad_triplona: ext.caducidad_triplona ? ext.caducidad_triplona : '',
                      caducidad_quiniela: ext.caducidad_quiniela ? ext.caducidad_quiniela : '',
                    });
                  }
                  datosTablas.push(datosExtracto);
                  // Ordena los datos de la tabla segun el tipo de sorteo
                  datosTablas.sort((a, b) => {
                    if (a[0].tipoid < b[0].tipoid) {
                      return -1;
                    } else if (a[0].tipoid > b[0].tipoid) {
                      return 1;
                    }
                    return 0;
                  });
                  contador++;
                  if (contador == cantidad) {
                    setDatosTablas(datosTablas);
                  }
                } else {
                  setDatosTablas(null); // Cuando existe alguna falla con los registros del extracto
                }
              });
            }
          );
        });
      } else {
        setDatosTablas(null);
      }
    });
  };
  const datetimeRef = useRef(null);
  const handleFechaChange = (momentDate) => {
    const fechaMuestra = momentDate.format("DD/MM/YYYY");
    const fechaComparar = momentDate.format("YYYY-MM-DD");
    setFecha({ fechaMuestra: fechaMuestra, fechaComparar: fechaComparar });
  };
  const handleIconClick = () => {
    datetimeRef.current._openCalendar(); // Abrir el calendario al hacer clic en el icono
  };

  return (
    <div className="mainSection my-4">
      <Row className="d-flex justify-content-center row-cols-2">
        <Col md={9} sm={12} xs={12} className="justify-content-center">
          <Row className="justify-content-center">
            <Col md={6}>
              <div className="fecha-selector">
                <label className="letraCaja">Ver resultados día:</label>
                <div className="fecha-input-container">
                  <FcCalendar 
                    className="icono-calendario" 
                    size={50} 
                    onClick={handleIconClick}
                    title="Hacer clic para abrir calendario"
                  />
                  <div>
                    <Datetime
                      ref={datetimeRef}
                      className="custom-datetime"
                      timeFormat={false}
                      dateFormat="DD/MM/YYYY"
                      inputProps={{
                        readOnly: true,
                        placeholder: "Seleccionar fecha",
                        "aria-label": "Seleccionar fecha para ver resultados",
                        title: "Seleccionar fecha"
                      }}
                      value={fecha.fechaMuestra}
                      onChange={handleFechaChange}
                      closeOnSelect={true}
                      locale="es"
                      isValidDate={(current) => {
                        // Permitir solo fechas pasadas y la fecha actual
                        return current.isBefore(moment().add(1, 'day'));
                      }}
                    />
                  </div>
                </div>
                <div className="text-center">
                  {datosTablas ? (
                    <h3
                      className="letraCajaResultado"
                      style={{ color: "#008285" }}
                    >
                      Resultados{" "}
                      {moment(fecha.fechaMuestra, "DD/MM/YYYY").format("DD")} de{" "}
                      {moment(fecha.fechaMuestra, "DD/MM/YYYY").format("MMMM").charAt(0).toUpperCase() + moment(fecha.fechaMuestra, "DD/MM/YYYY").format("MMMM").slice(1)}{" "}
                      de{" "}
                      {moment(fecha.fechaMuestra, "DD/MM/YYYY").format("YYYY")}{" "}
                    </h3>
                  ) : null}
                </div>
              </div>
            </Col>
          </Row>
          <Row className="row-tabla p-3">
            {datosTablas && datosTablas.length > 0 ? (
              datosTablas.map((tabla, index) => (
                <Col md={5} key={index}>
                  <TablasExtractos datos={tabla} />
                  {/* <SorteoComponent datos={tabla}/> */}
                </Col>
              ))
            ) : (
              <div className="row-tabla">
                <h3 className="letraCaja" style={{ fontSize: "150%", textAlign: 'center' }}>
                  No se realizaron sorteos en la fecha seleccionada
                </h3>
              </div>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );

};
export default SubirExtracto;
